export const PRODUCT_TYPE_NAMES = {
  GUIDED_PROJECT: 'GUIDED PROJECT',
  SELF_PACED_PROJECT: 'PROJECT',
  COURSE: 'COURSE',
  SPECIALIZATION: 'SPECIALIZATION',
  CERTIFICATE: 'CERTIFICATE',
  MASTERTRACK: 'MASTERTRACK',
  DEGREE: 'DEGREE',
} as const;

export type ProductTypeName = keyof typeof PRODUCT_TYPE_NAMES;

export const ProductVariantNames = {
  BachelorsDegree: 'BachelorsDegree',
  MastersDegree: 'MastersDegree',
  Mastertrack: 'MasterTrack',
  PostgraduateDiploma: 'PostgraduateDiploma',
  GraduateCertificate: 'GraduateCertificate',
  UniversityCertificate: 'UniversityCertificate',
} as const;

export type ProductVariantName = keyof typeof ProductVariantNames;
